import { StatIconName } from '../../../../ui-components/lib/stat/stat.model';
import { EMPLOYEE_ROUTES } from '../../../common/constants/employee.routing.constants';
import { Insight } from '../../../common/models/insight.model';

/** undefined = loading, null = request failed */
export type Loadable<T> = T | null | undefined;

export interface HomeTile {
  key: 'awaiting' | 'overdue' | 'open' | 'participated';
  label: string;
  icon: StatIconName;
  value: Loadable<number>;
  display: string;
  queryParams: Record<string, string>;
}

export interface ApprovalRow {
  id: number;
  creatorName: string;
  creatorImage: string;
  subject: string;
  flowName: string;
  stepName: string;
  overdue: boolean;
  age: string;
  link: string;
}

export const SHOWN = 6;
export const TABS = EMPLOYEE_ROUTES.MY_INBOX.TABS;

export function greetingKey(hour: number): string {
  if (hour < 12) return 'employee_home_greeting_morning';
  if (hour < 17) return 'employee_home_greeting_afternoon';
  return 'employee_home_greeting_evening';
}

export const AGE_UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ['year', 365 * 86400],
  ['month', 30 * 86400],
  ['day', 86400],
  ['hour', 3600],
  ['minute', 60],
];

/** "3 hours ago" in the given language; under a minute reads "now". */
export function relativeAge(
  iso: string,
  lang: string,
  now = Date.now()
): string {
  const seconds = Math.max(0, (now - Date.parse(iso)) / 1000);
  const rtf = new Intl.RelativeTimeFormat(lang, { numeric: 'auto' });
  const [unit, size] = AGE_UNITS.find(([, s]) => seconds >= s) ?? ['second', 1];
  return rtf.format(unit === 'second' ? 0 : -Math.floor(seconds / size), unit);
}

export const insightValue = (items: Insight[], key: string): number =>
  Number(items.find(i => i.key === key)?.value ?? 0);

/** "…" while loading, "—" when the request failed. */
export function displayCount(value: Loadable<number>): string {
  if (value === undefined) return '…';
  if (value === null) return '—';
  return String(value);
}
